module.exports = __webpack_public_path__ + "static/media/tela-passo-07.f1728799.jpg";